import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'

import { usePurifiedFormik } from '../../../../../hooks/formHooks/usePurifiedFormik'
import { getBudgetValidation } from '../../remainingBudgetValidation'

import CampaignEditForm from '../../CampaignEditForm'

import { getBudgetSectionType } from '../../../../Multiplatform/CampaignForms/typeHelpers'

import { updateCampaign } from '../../../../../modules/actions/campaigns'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../Multiplatform/CampaignForms/fields'
import { HISTORY_META_EDIT_SECTION } from '../../../../../constants/changeHistory'

const CampaignBudgetSectionForm = ({
  platform,
  adAccountId,
  campaign = {},
  remainingBudget,
  title,
  CampaignBudgetFormFields,
  editItemData,
  updateOptions,
  ...formProps
}) => {
  const dispatch = useDispatch()

  const budgetType = getBudgetSectionType(campaign[BUDGET_LIFETIME], campaign[BUDGET_DAILY])

  const handleSubmit = useCallback(
    values => {
      const { budget_lifetime, budget_daily } = values

      const updateCampaignData = {
        account: adAccountId,
        ...(budgetType === BUDGET_LIFETIME && { budget_lifetime }),
        ...(budgetType === BUDGET_DAILY && { budget_daily }),
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        }
      }

      dispatch(updateCampaign(updateCampaignData, campaign.id, platform, updateOptions))
    },
    [dispatch, title, campaign.id, platform, budgetType, adAccountId, updateOptions]
  )

  const initialValues = useMemo(
    () => ({
      [BUDGET_LIFETIME]: (campaign && String(campaign.budget_lifetime)) || '',
      [BUDGET_DAILY]: (campaign && String(campaign.budget_daily)) || ''
    }),
    [campaign]
  )

  const initialCampaignBudget = useMemo(() => campaign[BUDGET_LIFETIME] || campaign[BUDGET_DAILY], [campaign])

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
    validationSchema: getBudgetValidation({
      remainingBudget,
      initialBudget: initialCampaignBudget,
      budgetType
    })
  })

  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <CampaignEditForm initialValues={initialValues} formik={purifiedFormik} {...formProps}>
      <CampaignBudgetFormFields formik={formik} budgetType={budgetType} remainingBudget={remainingBudget} />
    </CampaignEditForm>
  )
}

CampaignBudgetSectionForm.propTypes = {
  platform: PropTypes.string.isRequired,
  adAccountId: PropTypes.string.isRequired,
  campaign: PropTypes.object.isRequired,
  remainingBudget: PropTypes.number.isRequired,
  title: PropTypes.string,
  editItemData: PropTypes.object,
  updateOptions: PropTypes.object
}

export default CampaignBudgetSectionForm
